import { gql } from '@apollo/client/core'
import type { UseActionResult, UseMutationProps } from '@ztechapps/common.hook'
import { useActionMutation } from '@ztechapps/common.hook'
import type { Product, ProductRequiredSerialNumberArgs } from '@ztechapps/common.contract'

export const productRequiredSerialNumberQuery = gql`
  mutation productRequiredSerialNumber($input: ProductRequiredSerialNumberArgs!) {
    productRequiredSerialNumber(input: $input) {
      _id
      requiredSerialNumber
    }
  }
`

export const useProductRequiredSerialNumber = (
  { query, ...props } = {} as UseMutationProps
): UseActionResult<Product, ProductRequiredSerialNumberArgs> => {
  query = query ?? productRequiredSerialNumberQuery

  return useActionMutation({
    query,
    ...props,
  })
}
